import { render } from "./HiToolButton.vue?vue&type=template&id=0936c032"
import script from "./HiToolButton.vue?vue&type=script&lang=js"
export * from "./HiToolButton.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__